import cn from "classnames"

import { Card, Flex, Text } from "@/atoms"
import { NAMES_ROUTES } from "@/const/routes.constants"
import { useTranslation } from "@/hooks/useTranslation"
import { useFeatureFlags } from "@/hooks/useUser"
import { ExternalLinkOutlined } from "@/icons"
import { Heading } from "@/molecules/Heading"
import { InformationPopover } from "@/molecules/InformationPopover/InformationPopover"
import { LinkButton } from "@/molecules/LinkButton"
import { ApplicationStatusPopover } from "@/pages/DiscoveryPage/components/molecules/ApplicationStatusPopover/ApplicationStatusPopover"
import { Statuses } from "./Statuses"
import { getApplicationsLabel } from "./helpers"

import styles from "./ImpactCard.module.scss"

import type { ImpactCardProps } from "."

export const ImpactCard = (props: ImpactCardProps) => {
  const { t } = useTranslation()
  const { t: tImpact } = useTranslation("translation", {
    keyPrefix: "triage.drawer.impact"
  })
  const kortexInstalled = useFeatureFlags("kortexInstalled")

  const { applicationCount: meta, riskId, projectName } = props.issue
  const { total } = meta
  const hasApplications = total > 0
  const { ROOT, APPLICATIONS } = NAMES_ROUTES.DISCOVERY

  return (
    <Card
      className={styles.card}
      title={
        <Flex flex={1} align="center" justify="space-between">
          <Heading
            level={5}
            title={tImpact("title")}
            classes={{ title: styles.title }}
          />
          <LinkButton
            className={cn(styles.linkButton, styles.linkButtonTransform)}
            size="small"
            target="_blank"
            icon={<ExternalLinkOutlined />}
            type="link"
            href={`/${ROOT}/${APPLICATIONS}?${new URLSearchParams({ projectName, riskId }).toString()}`}
            disabled={!hasApplications}
          >
            {tImpact("allApp")}
          </LinkButton>
        </Flex>
      }
    >
      <Flex flex={1} align="center" justify="space-between">
        <Text
          className={cn({
            [styles.textLowercase]: hasApplications,
            [styles.textTfNone]: !hasApplications
          })}
        >
          {getApplicationsLabel(props.issue, { kortexInstalled, t })}
        </Text>
        {hasApplications && (
          <InformationPopover.Popover
            placement="auto"
            classNamePopover={styles.popover}
            content={
              <InformationPopover.CommonTemplate title="Statuses">
                <ApplicationStatusPopover />
              </InformationPopover.CommonTemplate>
            }
          >
            <span>
              <Statuses
                active={meta.active}
                inactive={meta.inactive}
                terminated={meta.terminated}
                t={t}
              />
            </span>
          </InformationPopover.Popover>
        )}
      </Flex>
    </Card>
  )
}
